
import { Component, Vue, Prop } from "vue-property-decorator";
import WorkingHours from "../../../domain/restaurant/WorkingHours";
import WorkingHoursDialog from "@/components/restaurant/workingHours/WorkingHoursDialog.vue";
@Component({
  components: { WorkingHoursDialog }
})
export default class WorkingHoursCard extends Vue {
  @Prop({
    default: () => {
      return new WorkingHours();
    }
  })
  workingHours!: WorkingHours;

  dialog = false;

  showDialog() {
    this.dialog = true;
  }

  get newWorkingHours() {
    return this.workingHours.workingHoursId == null;
  }

  addWorkingHours(newWorkingHours: WorkingHours) {
    this.$emit("new-working-hours", newWorkingHours);
  }

  removeWorkingHours(toRemove: WorkingHours) {
    this.$emit("delete-working-hours", toRemove);
  }
}
